import { configureStore } from '@reduxjs/toolkit';
import CustomerDetailsReducer from './customerDetailsInfo';
import AppConfigReducer from './appConfigInfo';

export default configureStore({
  reducer: {
    customerDetailsInfo: CustomerDetailsReducer,
    appConfigInfo: AppConfigReducer,
  },
})